import i18n from '@/i18n';

export interface messageWithInterpolation {
    key: string;
    values: Record<string, string | number>;
}
export const displayErrorMessage = (
    errorMessage: string | messageWithInterpolation | undefined,
    isError: boolean,
) => {
    if (isError) {
        if (typeof errorMessage === 'string') {
            return i18n.t(errorMessage);
        }

        if (
            typeof errorMessage === 'object' &&
            errorMessage.key &&
            errorMessage.values
        ) {
            return i18n.t(errorMessage.key, errorMessage.values);
        }

        return i18n.t('something_wrong');
    }

    return null;
};
